import { useEffect } from "react";

const BRAND = "BazeBuild";

/** "Katalog", "Admin" → "Katalog · Admin · BazeBuild". A part that already names the brand is left as-is. */
export function formatDocumentTitle(...parts: Array<string | false | null | undefined>) {
  const bits = parts.map((part) => (typeof part === "string" ? part.trim() : "")).filter(Boolean);
  if (bits.length === 0) return BRAND;
  if (bits.some((part) => part.includes(BRAND))) return bits.join(" · ");
  return [...bits, BRAND].join(" · ");
}

export function useDocumentTitle(...parts: Array<string | false | null | undefined>) {
  const title = formatDocumentTitle(...parts);
  useEffect(() => {
    document.title = title;
  }, [title]);
}
